export default "__VITE_ASSET__UTNZHbhI__"